import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
// Context
import { AdminContext } from 'context/AdminContext';

// Pages
import ManageUsers from 'pages/UserAdmin';
import AddUser from 'pages/UserAdmin/AddUser';
import AmendUser from 'pages/UserAdmin/AmendUser';


const UserAdmin = () => {
  const { path } = useRouteMatch();
  return (
    <AdminContext>
      <Switch>
        <Route exact path={path}>
          <ManageUsers />
        </Route>
        <Route path={`${path}/add-user`}>
          <AddUser />
        </Route>
        <Route path={`${path}/amend-user/:userid`}>
          <AmendUser />
        </Route>
        <Route path="*">
          <p>404</p>
        </Route>
      </Switch>
    </AdminContext>
  );
};

export default UserAdmin;
